import { render, staticRenderFns } from "./jobStressBrainCardiovascularDetail.vue?vue&type=template&id=19f4ab32"
import script from "./jobStressBrainCardiovascularDetail.vue?vue&type=script&lang=js"
export * from "./jobStressBrainCardiovascularDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f4ab32')) {
      api.createRecord('19f4ab32', component.options)
    } else {
      api.reload('19f4ab32', component.options)
    }
    module.hot.accept("./jobStressBrainCardiovascularDetail.vue?vue&type=template&id=19f4ab32", function () {
      api.rerender('19f4ab32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/jbs/jobStressBrainCardiovascularDetail.vue"
export default component.exports